var lastHoveredChart;

Chart.defaults.global.hover.onHover = function(evt, charEl) {

	var currentlyShownChart;
	var currentlyHoveredItemIndex;
	var chartType;

	if(charEl.length > 0 ){
		lastHoveredChart = charEl[0]._chart.config.data;

		currentlyShownChart = window[lastHoveredChart.chartId].currentlyShownChart();
		currentlyHoveredItemIndex = window[lastHoveredChart.chartId].getCurrentlyHoveredItemIndex();
		chartType = window[lastHoveredChart.chartId].getChartType();

		//This function only needs to be run when vertical bars are being shown
		if(currentlyShownChart !== "vertical" || (chartType === 6 && currentlyShownChart === "vertical")) return;

		//if there is no hovered bar at the moment, return and do nothing
		if(currentlyHoveredItemIndex === undefined) return;
		//It should also highlight the other bar from the stack
		var otherBarIndex = -1;
		var stackValue;
		/**
			If the currently hovered bar's dataset has the stack key, let's store that value on
			the variable stackValue, and search if the previous or next items on the dataset array
			has the same stack value, meaning they are on the same bar. If they do we need to 
			highlight those also. So we save the index of that bar section on otherBarIndex,
			if there is no other bar section with the same stack we leave the index at -1
		*/
		if (lastHoveredChart.datasets[currentlyHoveredItemIndex] && "stack" in lastHoveredChart.datasets[currentlyHoveredItemIndex]){
 			stackValue = lastHoveredChart.datasets[currentlyHoveredItemIndex].stack;

			if(lastHoveredChart.datasets[currentlyHoveredItemIndex + 1] && lastHoveredChart.datasets[currentlyHoveredItemIndex + 1].stack === stackValue){
				otherBarIndex = currentlyHoveredItemIndex + 1;
			}else if(lastHoveredChart.datasets[currentlyHoveredItemIndex - 1] && lastHoveredChart.datasets[currentlyHoveredItemIndex - 1].stack === stackValue){
				otherBarIndex = currentlyHoveredItemIndex - 1;
			}
		}

		/**
			For each of the elements on the dataset that match the index we are currently hovering over (bar sections
			with the same stack value) lets give those elements the hoverBackgroundColor value. If they're not, then
			we do not add the value. And delete those keys just to make sure
		*/
		lastHoveredChart.datasets.forEach(function (d, i) {
			if(i === currentlyHoveredItemIndex || i === otherBarIndex){
				d.hoverBackgroundColor = lastHoveredChart.cca_meta.hoverColors[i];
			}else{
				delete d.hoverBackgroundColor;
			}
		});

	}else{
		/**
			If wer're not hovering over any bars we need to revert back the dataset items. Meaning,
			we need to delete the property hoverBackgroundColor
		*/
		if(lastHoveredChart){

			currentlyShownChart = window[lastHoveredChart.chartId].currentlyShownChart();
			currentlyHoveredItemIndex = window[lastHoveredChart.chartId].getCurrentlyHoveredItemIndex();
			chartType = window[lastHoveredChart.chartId].getChartType();

			//if I don't add this it removes the hover effects on the horizontal charts
			if(currentlyShownChart === "vertical" && chartType !== 6) {
				lastHoveredChart.datasets.forEach(function (d, i) {
					delete d.hoverBackgroundColor;
				});
			}
			lastHoveredChart = undefined;
		}
	}

	//Forces the chart to update
	this.update();
};

/**
	Draws the values of each dataset on the corresponding bar
*/
Chart.plugins.register({
	afterDraw: function(chart, easing) {

		// To only draw at the end of animation, check for easing === 1
		var ctx = chart.ctx;
		var vwWidth = jQuery(window).width();
		var currMeasure = vwWidth > 375 ? "desktop" : "mobile";
		var total = 0;
		var summaryValue = 0;
		var fontSize = currMeasure === "mobile" ? 15 : 22 ;
		var fontStyle = "bold";
		var fontFamily = "'korolev-condensed', 'sans-serif'";
		var fillStyle = "#fff";
		var benchmarkHor;
		var percentage;
		var valueToDraw;
		var isHorizontallyStacked;
		var horizontallyStackedValues = [];
		var scales = chart.config.options.scales;
		var isDonut = false;
		var isHorizontalBar = false;
		var isStackedHorizontalBar = false;

		//console.log("ctx.canvas", ctx.canvas)
		if(jQuery(ctx.canvas).is('[class^="donut-horizontal-"]')){
			isDonut = true;
		}
		
		if(jQuery(ctx.canvas).is('[class^="bar-horizontal-"]')){ //
			isHorizontalBar = true;
		}
		
		if(jQuery(ctx.canvas).is('[class^="bar-demo-horizontal-"]')){
			isStackedHorizontalBar = true;
		}

		var needToColorLabels = false; //used in type 6, if the summary value is too narrow for the labels to show we need to move the labels all to the right and color them appropiately

		var bgColorsBars = [
			"rgba(89,72,255,100)",
			"rgba(147,147,147,100)",
			"rgba(172,163,255,100)",
			"rgba(45,85,137,100)",
			"rgba(146,158,194,100)",
			"rgba(189,189,189,100)"
		];

		ctx.fillStyle = "#fff";
		ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

		//Checks if the canvas is of type horizontal
		if (isDonut || isHorizontalBar || isStackedHorizontalBar) {

			if(isDonut){
				fontSize = 22;
			}

			//We store the value of each bar on a total variable
			chart.data.datasets.forEach(function (dataset, i) {
				
				total += parseFloat(dataset.data[0]);

				if(dataset.benchmark){
					//we store the benchmark value on the benchmarkHor variable
					benchmarkHor = dataset.benchmark;
				}

				if(dataset.isPercentage){
					percentage = true;
				}

				if(dataset.horizontalStack !== undefined){
					isHorizontallyStacked = true;
					horizontallyStackedValues[dataset.horizontalStack] = {};
					horizontallyStackedValues[dataset.horizontalStack].pct = dataset.data[0];
					horizontallyStackedValues[dataset.horizontalStack].labelSup = dataset.labelSup;
					horizontallyStackedValues[dataset.horizontalStack].labelColor = dataset.checkboxColor;
					if(dataset.labelSup === false){
						summaryValue += parseFloat(dataset.data[0]);
					}
				}

			});

			if(summaryValue <= horizontallyStackedValues.length * 4 && horizontallyStackedValues.length > 1){
				needToColorLabels = true;
			}

			var meta = chart.getDatasetMeta(chart.data.datasets.length - 1);
			if (!meta.hidden) {
				meta.data.forEach(function(element, index) {

					// Make sure alignment settings are correct
					ctx.textAlign = "right";
					ctx.textBaseline = "middle";

					var padding = 10;

					if ((total / 6) > 1) {
						padding = padding + (total / 6);
					}

					var fromRight = percentage ? element._view.x - 20 : element._view.x - 10;
					var yPos = element._view.y;
					var xPos;

					//If the value of the bar is too long, go to the end of canvas, -10, and add text
					
					if(isDonut){
						var radius = element._model.outerRadius * 0.65;

						var quadr; //how many degrees we need to substract in order to get the angle in the first quadrant
						var axisOrientation; //indicates the axis orientation
						var quadrant;

						var percentToDegree = ((total - total * 0.25) * 360 / 100);

						if(percentToDegree <= 36){
							yPos = element._view.y;
							fromRight = element._view.x;
							ctx.fillStyle = "#282828";
						}else{
							var toRadians = (90 - 60) * (Math.PI / 180);
							fromRight = element._view.x + (Math.sin(toRadians) * radius);
							yPos = element._view.y + ((Math.cos(toRadians) * radius) * -1);
						}

						//ctx.textAlign="center";

					}else{
						if (element._view.x > element._xScale.right) {
							fromRight = element._xScale.right - 10;
						}
					}

					//calculate the space between benchmark and the rest of the bar
					if(benchmarkHor){
						var stackExcess = total - benchmarkHor;
						//if the tick is either 8 or 200, the amount of space should vary
						var valueForSpace, spaceToAdd;
						if(scales.xAxes[0].ticks.max === 8){
							valueForSpace = 0.3;
							spaceToAdd = 30;
						}else{
							valueForSpace = 11;
							spaceToAdd = 45;
						}

						var stackExcessInPx = (stackExcess * jQuery(ctx.canvas).width()) / scales.xAxes[0].ticks.max;

/* 						console.log("stackExcess", stackExcess);
						console.log("stackExcess to pixels width", (stackExcess * vwWidth) / scales.xAxes[0].ticks.max);
						console.log("ctx.measureText(total).width + 10 padding", ctx.measureText(total).width + 10);
						console.log("=====");
 */
						if(stackExcessInPx < (ctx.measureText(total).width + 10) && stackExcess > 0){ //these values might have to be calculated based on the window width
							fromRight = element._view.x + 10 + ctx.measureText(total).width;
							//fromRight = element._view.x + 0;
							ctx.fillStyle = "#282828";
						}
					}

					if(isHorizontallyStacked){
						ctx.textAlign = "right";
						var acc = 0; //in order for me to calculate the hor pos correctly I need to add the percentage values in this variable
						for (var i = 0; i < horizontallyStackedValues.length; i++) {
							acc+= horizontallyStackedValues[i].pct;
							var horPosOfStack = (element._view.x * acc) / total;
							var percentageTextWidth = 0;
							var lenghtOfTextLabel;
							var aux2;

							//calculate superscript
							if(horizontallyStackedValues[i].labelSup === false){
								ctx.font = Chart.helpers.fontString(fontSize / 2, fontStyle, fontFamily);
								percentageTextWidth = ctx.measureText("%").width;
							}
							ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

							valueToDraw = horizontallyStackedValues[i].labelSup === false ? percentage ? horizontallyStackedValues[i].pct.toString() : horizontallyStackedValues[i].pct.toString() : horizontallyStackedValues[i].labelSup;
							
							lenghtOfTextLabel = ctx.measureText(valueToDraw).width + percentageTextWidth;
							//WORKAROUND!!
							aux2 = horizontallyStackedValues.length > 1 ? 17 : 21;
							
							horPosOfStack = horizontallyStackedValues[i].labelSup === false ? horPosOfStack - aux2 : ((acc - (horizontallyStackedValues[i].pct / 2)) / 100) * element._view.x;
							ctx.fillStyle = horizontallyStackedValues[i].labelSup === false ? "#FFFFFF" : horizontallyStackedValues[i].labelColor;

							valueToDraw = valueToDraw.toString();

							//if stack is to short, put the text after stack
							if(horizontallyStackedValues[i].pct < 5 && horizontallyStackedValues[i].labelSup === false){
								var AmountToAddWhenTotalIsSmall = summaryValue < 5 && horizontallyStackedValues.length > 1 ? i * 20 : 0;
								horPosOfStack = 5 + horPosOfStack + (lenghtOfTextLabel * 2) + AmountToAddWhenTotalIsSmall;
								ctx.fillStyle = needToColorLabels ? horizontallyStackedValues[i].labelColor : "#282828";
							}

							//calculate superscript
							if(horizontallyStackedValues[i].labelSup === false){
								ctx.font = Chart.helpers.fontString(fontSize / 2, fontStyle, fontFamily);
								ctx.fillText("%", horPosOfStack+ctx.measureText("%").width, yPos-3.5);
							}
							ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

							ctx.fillText(valueToDraw, horPosOfStack, yPos);

						}

						jQuery(chart.canvas).parent().find(".type-6-sum-pct").html(summaryValue.toString() + "<span class='pct-sup'>%</span>");

					}else{
						valueToDraw = total.toString();

						var totalInPx = (total * jQuery(ctx.canvas).width()) / 100;
						var widthOfTextPx = ctx.measureText(valueToDraw).width + 10;
						widthOfTextPx = percentage ? widthOfTextPx + ctx.measureText("%").width : widthOfTextPx;
						
/* 						console.log("valueToDraw", valueToDraw);
						console.log("total", total);
						console.log("totalInPx", totalInPx);
						console.log("widthOfTextPx", widthOfTextPx); console.log("======="); */

						if(totalInPx < widthOfTextPx && !benchmarkHor && !isDonut){
							fromRight = element._view.x + 10 + 5;
							ctx.fillStyle = "#282828";
							ctx.textAlign="right";
						}else if((totalInPx - widthOfTextPx) < 2  && !benchmarkHor && !isDonut){
							fromRight = element._view.x + 10 + 5;
							ctx.fillStyle = "#282828";
							ctx.textAlign="right";	
						}
						
						ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
						ctx.fillText(valueToDraw, fromRight, yPos);
						if(percentage){
							ctx.font = Chart.helpers.fontString(fontSize / 2, fontStyle, fontFamily);
							ctx.fillText("%", fromRight+ctx.measureText("%").width + 1,yPos-(ctx.measureText("%").width/3.5));
						}
					}

				});
			}
		} else {
			//VERTICAL PART OF THE DRAWING OF VALUES
			//accumulated values of partial bars, for each data stack
			var total = [];
			//only the first member of the stack has the benchmark property, so I need to save the value in an array
			//to use it later
			var benchmarkValues = [];

			//first whe calculate all the values for each stack
			chart.data.datasets.forEach(function(dataset, i) {
				//We store the value of each bar on a total variable, depending on the stack value
				if(!total[dataset.stack]){
					total[dataset.stack] = parseFloat(dataset.data[0]);
				}else{
					total[dataset.stack] += parseFloat(dataset.data[0]);
				}

				if(dataset.isPercentage){
					percentage = true;
				}

				//Stores the benchmark value for each stack
				if(dataset.benchmark){
					benchmarkValues[dataset.stack] = dataset.benchmark;
				}

			});

			chart.data.datasets.forEach(function(dataset, i) {
				/**
					We check if the next dataset item in the dataset has the same stack value,
					meaning they are part of the same stacked bar 
				*/
				if(chart.data.datasets[i+1] && chart.data.datasets[i+1].stack === dataset.stack){
					//do nothing
				}else{
					/**
						If we know that the next dataset has a diferent stack value, then we draw 
						the current stack with the accumulated values in the total array
					*/
					var meta = chart.getDatasetMeta(i);
					meta.data.forEach(function(element, idx) {
						ctx.textAlign = "center";
						ctx.textBaseline = "top";
						ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
					  
						var fromTop = element._view.y + 8;

						//text for vertical bars
						var value, yPos;

						//For DU stack
						if (element._view.y < 0) {
							fromTop = 10;
						}

						xPos = element._view.x;
						if(dataset.data[0] > 0){

							//if the stack value - benchmark is < 0.5, means there is no 
							//room between benchmark and second part of stack for value to fit
							//so It goes on top of the whole bar, in black
							var textColor = fillStyle;
							var stackExcess = total[dataset.stack] - benchmarkValues[dataset.stack];

							//if the tick is either 8 or 200, the amount of space should vary
							var valueForSpace;
							if(scales.yAxes[0].ticks.max === 8){
								valueForSpace = 0.5;
							}else{
								valueForSpace = 13;
							}

							value = total[dataset.stack].toString();

							if(stackExcess <= valueForSpace && stackExcess > 0){
								fromTop = element._view.y - 25;
								textColor = "#282828";
								yPos = fromTop;
							}else{
								if(percentage){
									yPos = parseInt(value) <= 8 ? element._view.y - 25 : fromTop;
									textColor = parseInt(value) <= 8 ? "#282828" : "#FFF";
								}else{
									yPos = fromTop;
									textColor = "#FFF";
								}
							}
							
							ctx.fillStyle = textColor;

							//si existe benchmark es otro el criterio

							if(!percentage){
								if(value.length > 3){
									fontSize = percentage ? 10 : 16;
								}else if(value.length === 3){
									fontSize = percentage ? 12 : 18;
								}
							}else{
								//if the text is too long >4 chars, we need to make font smaller
								if(value.length > 3 && dataset.dataUnavailableLabel === false && value !== "DU"){
									fontSize = percentage ? 10 : 16;
								}else if(value.length === 3 && dataset.dataUnavailableLabel === false && value !== "DU"){
									fontSize = percentage ? 12 : 18;
								}

								fontSize = percentage && dataset.dataUnavailableLabel === false && value !== "DU" ? 16.5 : fontSize;
							}


							ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);

						}else{

							fontSize = currMeasure === "mobile" ? 15 : 22;
							//OJO!!!!!!!!!!!!!!!!!!
							value = dataset.hasOwnProperty("dataUnavailableLabel") && dataset.dataUnavailableLabel !== false ? dataset.dataUnavailableLabel : "DU";
							ctx.fillStyle = bgColorsBars[dataset.stack];
							yPos = element._yScale.bottom - 23.5;
							xPos = element._view.x;
						}

						ctx.textAlign="center";

						var valueToDraw = value;
						var percentageSpaceToRemoveOnX = 0;
						var percentageSpaceToRemoveOnXValue;
						//just to calculate the x spacing when percentage
						if(percentage && dataset.dataUnavailableLabel === false && value !== "DU"){
							percentageSpaceToRemoveOnXValue = ctx.measureText(valueToDraw).width;
							ctx.font = Chart.helpers.fontString(fontSize / 2, fontStyle, fontFamily);
							percentageSpaceToRemoveOnX = (percentageSpaceToRemoveOnXValue + ctx.measureText("%").width) / 5;
						}
						
						ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
						ctx.fillText(valueToDraw, xPos - percentageSpaceToRemoveOnX, yPos);

						if(percentage && dataset.dataUnavailableLabel === false && value !== "DU"){
							ctx.font = Chart.helpers.fontString(fontSize / 2, fontStyle, fontFamily);
							ctx.fillText("%", xPos+percentageSpaceToRemoveOnX+(percentageSpaceToRemoveOnX / 2),yPos+(ctx.measureText("%").width/3));
						}
					});
				}
			});
		}
	}
});

//function to draw black line across graph (adapted from here: https://plnkr.co/edit/ubR7Luf4NisgxqR2sVUr?p=preview)
var originalLine = Chart.controllers.horizontalBar.prototype.draw;
Chart.helpers.extend(Chart.controllers.horizontalBar.prototype, {
	draw: function () {
		originalLine.apply(this, arguments);

		var chart = this.chart;
		var ctx = chart.chart.ctx;

		var index = chart.config.options.lineAtIndex;
		var lineDrawn = chart.config.options.lineDrawn;
		if (index) {
			var xaxis = chart.scales["x-axis-0"];
			var yaxis = chart.scales["y-axis-0"];

			var x1 = xaxis.getPixelForValue(index);                       
			var y1 = yaxis.top;                                                   

			var x2 = xaxis.getPixelForValue(index);                       
			var y2 = yaxis.bottom;                                        

			ctx.lineWidth = 3;
			ctx.save();
			ctx.beginPath();
			ctx.moveTo(x1, y1);
			ctx.strokeStyle = "black";
			ctx.lineTo(x2, y2);
			ctx.stroke();
			ctx.restore();
		}
	}
});

//Draws the benchmarks for the vertical bars
var originalLineDraw = Chart.controllers.bar.prototype.draw;
Chart.helpers.extend(Chart.controllers.bar.prototype, {
	draw: function() {
		originalLineDraw.apply(this, arguments);

		var chart = this.chart;
		var ctx = chart.chart.ctx;

		var xaxis = chart.scales["x-axis-0"];
		var yaxis = chart.scales["y-axis-0"];

		var limits = new Array();

		var line1 = new Array();
		line1["value"] = chart.config.data.line1;
		line1["label"] = "";
		line1["color"] = "#000";
		limits.push(line1);

		var line2 = new Array();
		line2["value"] = chart.config.data.line2;
		line2["label"] = "";
		line2["color"] = "#000";
		limits.push(line2);

		var line3 = new Array();
		line3["value"] = chart.config.data.line3;
		line3["label"] = "";
		line3["color"] = "#000";
		limits.push(line3);

		var line4 = new Array();
		line4["value"] = chart.config.data.line4;
		line4["label"] = "";
		line4["color"] = "#000";
		limits.push(line4);

		for (var i = 0; i < limits.length; i++) {

		  //Refactor the value
		  limits[i].value = yaxis.getPixelForValue(limits[i].value, undefined);
		  ctx.fillStyle = "black";
		  ctx.lineWidth = 3;
		  ctx.fillText(limits[i].label, 35, limits[i].value - 5);

		  ctx.save();
		  ctx.beginPath();
		  ctx.moveTo(xaxis.left, limits[i].value);
		  ctx.strokeStyle = limits[i].color;
		  ctx.lineTo(xaxis.right, limits[i].value);
		  ctx.stroke();
		  ctx.restore();
		}
	}
});

//Fonts
Chart.defaults.global.defaultFontFamily = "'korolev-condensed', 'sans-serif'";
Chart.defaults.global.defaultFontSize = 18;
Chart.defaults.global.defaultFontColor = "#282828";